import { SWAP_SITE_HOST } from '../config/siteContent';

export const normalizeHostname = (hostname = '') =>
  hostname.trim().toLowerCase().replace(/\.$/, '');

export const getCurrentHostname = () => {
  if (typeof window === 'undefined') {
    return '';
  }

  return normalizeHostname(window.location.hostname);
};

export const isSwapHostname = (hostname = getCurrentHostname()) =>
  normalizeHostname(hostname) === SWAP_SITE_HOST;
